import { render, staticRenderFns } from "./InfoReport.vue?vue&type=template&id=27e13efa&scoped=true&"
import script from "./InfoReport.vue?vue&type=script&lang=js&"
export * from "./InfoReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e13efa",
  null
  
)

export default component.exports